import React, { useState, useEffect } from 'react';
import { ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select, Checkbox, message, Spin, Upload, Space } from 'antd';
import { DatePicker, CKEditor } from 'components/atoms';
import { fetcher } from 'services';
import { useMailTemplateCode, useRefCode } from 'hooks'
import moment from 'moment';
import { MSG } from 'commons/constants';
import { UploadFile } from 'antd/lib/upload/interface';
import { UploadOutlined,CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import { usePopupManager } from 'react-popup-manager';

export interface MultiMailSendFormProps extends PopupProps {
    ids: string;
    mail_group: string;    
    toStudents: string;
    toCrms: string;
    mail_type?: string;
    onCancel?: () => void;
    onConfirm?: () => void;
}

export interface FileInfoType {
    fileid: number, 
    filename: string    
}

const MultiMailSendForm = ({ ids, mail_group, toStudents, toCrms, mail_type='', onCancel, onConfirm }: MultiMailSendFormProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [isSendDate, setIsSendDate] = useState<boolean>(false);
  const [mailBody, setMailBody] = useState<string>('');  
  const [isLoding, setIsLoading] = useState<boolean>(false);  
  const [mailType, setMailType] = useState<string>(mail_type); 
  const [mailId, setMailId] = useState<number>(); 
  const [mailFileList, setMailFileList] = useState<UploadFile[]>([]);  
  const [tmpplateInfo, setTemplateInfo] = useState<MailTemplateDto>(); 
  
  /* ======================================================
  * hooks
  * ====================================================== */

    const { refCodeList } = useRefCode({field: mail_group+'_mail_type', status_type: 'AV'});   
    const { codeList } = useMailTemplateCode({params: {group: mail_group, mail_type: mailType} })

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { open } = usePopupManager(); 
   /* ======================================================
   * events
   * ====================================================== */
    const onSubmit = (e) => {

        setIsLoading(true);        
        fetcher.b2c.postStudentMultiMailSend ({
            ids: ids,
            mail_id: mailId,
            mail_group: mail_group,
            mail_type: mailType,
            subject: e.subject,
            mail_body: mailBody,
            mail_cc: e.mail_cc,
            send_date: moment(e.send_date).format('YYYY-MM-DD HH:mm'),
            send_date_yn: isSendDate?'Y':'N',
            status: isSendDate?'30':'20',
            fileData: mailFileList.map((file) => file.originFileObj),
        })
        .then((res) => {
            setIsLoading(false);            
            switch (res.code) {
                case 200:
                    message.info(MSG.SUCCESS_MAIL_SEND, 1);
                    onConfirm?.();
                break;
                default:  
                break;
            };
        }); 

    };
    
    const getMailContent = (mail_type: string, mail_id: number) => {
        setIsLoading(true);
        fetcher.mailtemplate.postMailTemplateInfo ({
            id: mail_id,
            mail_type: mail_type,     
        })
        .then((res) => {
            setIsLoading(false);            
            switch (res.code) {
                case 200:
                    if (!!res.result) {
                        setTemplateInfo(res.result?.info);
                    }
                break;
                default:  
                break;
            };
        });       
    }
          
    /* ======================================================
    * methods
    * ====================================================== */
 
       
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        if (!!mailId && !!mailType) {
            getMailContent(mailType, mailId)
        } else {
            setTemplateInfo({
                id: 0,
                mail_type: mailType,
                mail_type_title: '',
                mail_group: '',
                mail_group_name: '',
                mail_type_name: '',
                subject: '',
                mail_body: '',
                mail_to: '',
                mail_cc: '',
                created_at: '',
            })
        }
    }, [mailId, mailType]);

    useEffect(() => {
        if (!!tmpplateInfo) {
            form.setFieldsValue({
                subject: tmpplateInfo.subject,
                mail_cc: tmpplateInfo.mail_cc,
                mail_body: tmpplateInfo.mail_body,
            });
            setMailBody(tmpplateInfo.mail_body); 
        }
    }, [tmpplateInfo]);

    useEffect(() => {
        if (!!mail_type) {
            (mail_type==='type06')?form.setFieldValue('mail_to', toCrms):form.setFieldValue('mail_to', toStudents);
        }
    }, []);    
    
    return (
        <div style={{width:'100%'}}>
            <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <Form
                form={form}
                name="LecturerInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >   
                {(!mail_type) && (
                <Form.Item name="mail_type" label={'타입'} rules={[{ required: true, message: '' }]}>
                  <Select placeholder="보내실 메일 타입을 선택하세요." 
                    options={refCodeList?.map((item) => {return {label: item.value, value: item.name}})} 
                    onChange={(value) => {
                        setMailType(value); 
                        setMailId(undefined);
                        form.setFieldValue('mail_id', null); 
                        (value==='type06')?form.setFieldValue('mail_to', toCrms):form.setFieldValue('mail_to', toStudents);
                    }}
                />                
                </Form.Item>                               
                )}
                <Form.Item name="mail_id" label={'유형'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        options={codeList}
                        onChange={(value)=>{
                            setMailId(value);
                            getMailContent(mailType, value);
                        }}
                        placeholder="보내실 메일 유형을 선택하세요."
                    />               
                </Form.Item> 
                <Form.Item name="subject" label={'제목'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='메일 제목을 입력하세요'/>                    
                </Form.Item>      
                <Form.Item name="mail_to" label={'받는사람'} rules={[{ required: true, message: '' }]}>
                    <Input.TextArea autoSize readOnly/>                    
                </Form.Item>   
                <Form.Item name="mail_cc" label={'참조'}>
                    <Input type="text" placeholder='이메일을 입력하세요'/>                    
                </Form.Item> 
                <Form.Item name="file_id" label={'첨부파일'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={mailFileList}
                            onChange={({ fileList: list }) => {
                                setMailFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {mailFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setMailFileList(mailFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                        
                </Form.Item>                         
                <Form.Item name="mail_body" label={'내용'} rules={[{ required: true, message: '' }]}>
                    <CKEditor 
                        className='ck-reply-writer'
                        data={tmpplateInfo?tmpplateInfo.mail_body:''}
                        onSetData={setMailBody}
                    />  
                </Form.Item> 
                <Form.Item label={'예약발송'}>
                    <Form.Item 
                        name="send_date_yn" 
                        valuePropName="checked"
                        style={{ display: 'inline-block' }}                  
                    >   
                        <Checkbox onChange={(e)=>setIsSendDate(e.target.checked)}>예약발송확인</Checkbox>  
                    </Form.Item> 
                    <Form.Item 
                        style={{ display: 'inline-block' }}
                        name="send_date" 
                        rules={[{ required: isSendDate, message: '' }]}
                    >   
                        <DatePicker 
                            showTime={true}
                            format="YYYY-MM-DD HH:mm"
                            disabled={!isSendDate}
                            minuteStep={5} 
                        />  
                    </Form.Item>            
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCancel} style={{marginRight: "5px"}}>취소</Button>
                    </div>
                    <div>
                        <Button htmlType="submit"  type="primary" >발송</Button>
                    </div>
                </ButtonGroup>
            </Form>
            </Spin>
        </div>
    )    
};

export default React.memo(MultiMailSendForm);    